import { MODELS } from '../Lib/constants';
import { getUser } from '../AppServices';

export const dmsURI = () => {
  const user = getUser();

  return {
    query: {
      id: 'cdkROList',
      addOnFilter: {
        dealer: user.dealer,
      },
    },
    aggregate: true,
    model: MODELS.CDKRepairOrder,
  };
};
